import { Component, computed, ElementRef, linkedSignal, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { AgGridEditorOptions, AgGridEditorParams } from "./types";

@Component({
  selector: "ag-grid-input-editor",
  template: `
    <input
      class="bm-input w-full h-full"
      [type]="type()"
      [ngModel]="inputValue()"
      (ngModelChange)="outputValue.set($event)"
      #input
    />
  `,
  host: {
    class: "block w-full h-full p-1",
  },
  imports: [FormsModule],
})
export class AgGridInputEditorComponent<TData> implements ICellEditorAngularComp {
  public static options<TData, TValue = string>(options: AgGridEditorOptions<TData, TValue>) {
    return options;
  }

  protected input = viewChild<ElementRef<HTMLInputElement>>("input");
  protected params = signal<AgGridEditorParams<TData, string>>(null);
  protected type = computed(() => this.params()?.type || "text");
  protected inputValue = computed(() => {
    const params = this.params();
    let value = params.value;
    if (params.readValue) {
      value = params.readValue(params.data);
    }
    return value;
  });
  protected outputValue = linkedSignal<string>(() => this.inputValue());

  public agInit(params: AgGridEditorParams<TData, string>) {
    this.params.set(params);
  }

  public refresh(params: AgGridEditorParams<TData, string>) {
    this.params.set(params);
    return true;
  }

  public getValue() {
    const value = this.outputValue();
    if (this.inputValue() !== value && this.params().writeValue) {
      this.params().writeValue(this.params().data, value);
    }
    return value;
  }

  public afterGuiAttached(): void {
    this.input()?.nativeElement.focus();
  }

  protected async handleCancelClicked() {
    this.params().stopEditing();
  }
}
